











import { defineComponent, ref, PropType, onMounted, computed } from 'vue-demi';
import { SubTplInfo } from './types';
import WxSubscribe from '@tencent/wphk-components-wx-subscribe/index.vue';
import { handleSubscribeRes, checkIfSubscribed } from './business/index';
import { i18n } from '../i18n';
import { isSupportWxSubscribe } from '@tencent/wphk-components-wx-subscribe/wx-subscribe-util';
import { biClick } from '@tencent/fit-bi-sdk';
import { getHasFavorites } from './api/index';
import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';

export default defineComponent({
  name: 'MerchantSubscribe',
  props: {
    /** 商户id */
    spId: String,
    /** 订阅渠道id，传给后端的 */
    chnId: {
      type: String,
      required: true,
    },
    /** 订阅模版信息 */
    subTplInfo: {
      type: Array as PropType<SubTplInfo[]>,
      required: true,
      default: () => ([]),
    },
  },
  components: {
    WxSubscribe,
  },
  setup(props, { emit }) {
    const isSubscribed = ref(true);
    const hasFavorites = ref(false);
    const isWxSupport = ref(isSupportWxSubscribe());
    const tplIds = computed(() => props.subTplInfo.map(item => item.tplId));
    const isShow = computed(() => (props.spId ? hasFavorites.value && isWxSupport.value
      && !isSubscribed.value : isWxSupport.value && !isSubscribed.value));

    async function subscribeInit() {
      isSubscribed.value = await checkIfSubscribed(props.chnId, props.subTplInfo);
    }
    async function spFavoritesInit() {
      const [err, res] = await to(getHasFavorites(props.spId || ''));
      if (err) {
        throw new CustomException(err, 'getHasFavoritesFail', '查询商户收藏报错');
      }
      hasFavorites.value = res;
    }

    onMounted(async () => {
      if (props.spId) {
        Promise.all([subscribeInit(), spFavoritesInit()]);
      } else {
        subscribeInit();
      }
    });
    return {
      isShow,
      tplIds,
      subSucc(res) {
        biClick('merchant-subscribe.click|订阅点击');
        const hasOneAccept = handleSubscribeRes(res, props.chnId, props.subTplInfo);
        if (hasOneAccept) {
          isSubscribed.value = true;
          biClick('merchant-subscribe.succ|订阅成功');
        }
      },
      subFail() {
        biClick('merchant-subscribe.fail|订阅失败');
      },
      i18n,
    };
  },
});
